module.exports = __webpack_public_path__ + "static/media/background-loading.3bbca30b.jpg";